import Vue from 'vue'
import Vuex from 'vuex'
import pkg from '../../../../package.json'
import * as actions from './actions'
import * as getters from './getters'

import app from './modules/app'
import menu from './modules/menu'

import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

const store = new Vuex.Store({
  strict: true,  // process.env.NODE_ENV !== 'production',
  actions,
  getters,
  modules: {
    app,
    menu
  },
  state: {
    pkg,
    auth: true,
    channel_id: 1
  },
  mutations: {
    updateChannel (state, channel_id) {
      this.state.channel_id = channel_id
    }
  },
  plugins: [
    createPersistedState()
  ]
})

export default store



// WEBPACK FOOTER //
// ./resources/assets/js/store/index.js